import { JobPostingPage } from './JobPostingPage';
import { WorkingInterviewPage } from './WorkingInterviewPage';
import { ReviewAndPaymentPage } from './ReviewAndPaymentPage';

export const CreatePermanentJobPosting = {
  JobPostingPage,
  WorkingInterviewPage,
  ReviewAndPaymentPage,
};
